import { createStore } from 'vuex'
import {
  getSiteInfo,
  getToken,
  getRefreshToken,
  getLoginState,
  setToken,
  setLoginState,
  removeToken,
  getUserInfo,
  setUserInfo,
  setSiteInfo,
  setRefreshToken
} from "@/utils/storage";
import { getSiteInit, getUploadUrl } from "@/api/system";
import {getUserInfo as getUserInfoApi, refreshToken, login, logOut, verifyAuthCode} from "@/api/auth";
const getDefaultState = () => {
  return {
    token: getToken(),
    site_info: getSiteInfo(),
    refresh_token: getRefreshToken(),
    loginState: Number(getLoginState()) && getToken(),
    user_info: getUserInfo() || {},
    uploadUrl: '',
  }
}
export default createStore({
  state: getDefaultState(),
  mutations: {
    SET_TOKEN: (state, data) => {
      state.token = data.token
      setToken(data.token)
    },
    RESET_STATE: state => {
      Object.assign(state, getDefaultState())
    },
    REMOVE_TOKEN: state => {
      state.token = ''
      removeToken() // 清除token
      setLoginState(0)
    },
    SET_SITE_INFO: (state, siteInfo) => {
      setSiteInfo(siteInfo)
      state.site_info = siteInfo
    },
    SET_USER_INFO: (state,data) => {
      Object.assign(state.user_info,data)
      setUserInfo(state.user_info)
    },
    SET_REFRESH_TOKEN: (state, data) => {
      state.refresh_token = data.refresh_token
      setRefreshToken(data.refresh_token)
    },
    SET_LOGIN_INFO: (state, data) => {
      state.token = data.token
      setToken(data.token)
      state.user_info = data
      if(data.isInit) {
        state.loginState = true
        setLoginState(1)
      }
      setUserInfo(data)
      if(data.refreshToken){
        state.refresh_token = data.refreshToken
        setRefreshToken(data.refreshToken)
      }
    },
    SET_UPLOAD_URL: (state, url) => {
      state.uploadUrl = url
    },
    SET_LOGIN_STATE: (state) => {
      state.loginState = true
      setLoginState(1)
    }
  },
  actions: {
    //登录
    login(context, userInfo) {
      return new Promise((resolve, reject) => {
        login(userInfo).then(res => {
          if(res.data) {
            if(res.data.token){
              context.commit('SET_LOGIN_INFO',res.data)
            }
            if(res.data.uuid){
              let siteInfo = getSiteInfo()
              siteInfo.uuid = res.data.uuid
              context.commit('SET_SITE_INFO',siteInfo)
            }
            resolve(res)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    verifyLogin(context, userInfo) {
      return new Promise((resolve, reject) => {
        verifyAuthCode(userInfo).then(res => {
          if(res.data) {
            context.commit('SET_LOGIN_INFO',res.data)
            if(res.data.uuid){
              let siteInfo = getSiteInfo()
              siteInfo.uuid = res.data.uuid
              context.commit('SET_SITE_INFO',siteInfo)
            }
            resolve(res)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 退出登录
    logout({ commit }){
      return new Promise((resolve, reject) => {
        logOut().then(res => {
          commit('REMOVE_TOKEN')
          commit('RESET_STATE')
          if (res.code) resolve()
          else reject('error')
        })
      })
    },
    // 获取站点信息
    setSiteInfo({ commit }) {
      return new Promise((resolve, reject) => {
        getSiteInit().then(res => {
          if(res.data) {
            if(process.env.NODE_ENV === 'development') console.log(res.data)
            commit('SET_SITE_INFO',res.data)
            resolve(res)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取用户信息
    setUserInfo({ commit }){
      return new Promise((resolve, reject) => {
        getUserInfoApi().then(res => {
          if(res.data) {
            if(process.env.NODE_ENV === 'development') console.log(res.data)
            commit('SET_USER_INFO',res.data)
            resolve(res)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 刷新token
    resetToken(context){
      return new Promise((resolve, reject) => {
        refreshToken().then(res => {
          context.commit('SET_TOKEN',res.data)
          context.commit('SET_REFRESH_TOKEN',res.data)
          if(res.data.uuid){
            let siteInfo = getSiteInfo()
            siteInfo.uuid = res.data.uuid
            context.commit('SET_SITE_INFO',siteInfo)
          }
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 更新上传url地址
    updateUploadUrl({ commit }) {
      return new Promise((resolve, reject) => {
        getUploadUrl().then(res => {
          res.data.size = res.data.size*1024
          commit('SET_UPLOAD_URL',res.data.uploadUrl)
          if (res.code) resolve(res.data)
          else reject('error')
        })
      })
    },
  },
  modules: {
  }
})
